/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';

import CMSScreen from '@/screens/setting/cms/CMSScreen';
import CMSDetailScreen from '@/screens/setting/cms/CMSDetailScreen';
import CMSFormScreen from '@/screens/setting/cms/CMSFormScreen';

const Stack = createStackNavigator();

const CMSNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  const showAddButton = hasNoAccess([
    'sales_supervisor',
    'branch_head',
    'finance_supervisor',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'general_manager',
    'vice_president',
    'vice_president_finance',
    'budget_controller',
    'finance_head',
    'tax_support',
    'billing_supervisor',
    'regional_distributor_manager',
  ]);

  return (
    <Stack.Navigator
      initialRouteName="CMSScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CMSScreen"
        component={CMSScreen}
        options={(props) => ({
          title: setTitleHeader('CMS'),
        })}
      />
      <Stack.Screen
        name="CMSFormScreen"
        component={CMSFormScreen}
        options={(props) => {
          const route = props.route;
          // The specific page type is now chosen inside the form itself (Page Type field),
          // so there's no longer a route param to derive a specific "Add Info/Guideline Page"
          // title from before the form even loads.
          let title = 'Add CMS';
          const isEdit = Boolean(route.params && route.params.titleScreen);
          if (isEdit) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                isJump={true}
                customBack={{
                  // Edit → back to the detail it was opened from; add → the list.
                  screen: isEdit ? 'CMSDetailScreen' : 'CMSScreen',
                  params: isEdit ? route.params : undefined,
                }}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="CMSDetailScreen"
        component={CMSDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'CMS';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }

          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() to the list (not pop) so back survives a browser
                // refresh, where the list isn't in the fresh stack.
                onPress={() => props.navigation.navigate('CMSScreen')}
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : showAddButton ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() =>
                    props.navigation.navigate(
                      'CMSFormScreen',
                      props?.route?.params,
                    )
                  }
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CMSNavigator;
